// extracted by mini-css-extract-plugin
module.exports = {"AppTableHeader":"AppTableHeader_3bXvl"};